import { render } from "./Tem013.vue?vue&type=template&id=02b5de68"
import script from "./Tem013.vue?vue&type=script&lang=js"
export * from "./Tem013.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__